<section class="page__section -small-bottom">
    <manage-calendar></manage-calendar>
</section>
